// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"19": "64ff0930f1d27491","339": "8a7f64756e6b13ab","419": "af39b5379e862c16","819": "d5369d3edcd031ee",}[chunkId] + ".js"
}